import Vue from 'vue';
import noty from './noty.service';

export default {
  async getSettingsByClient(clientId) {
    return (await Vue.http.get(`/api/galaxsys/settings/byclient/${clientId}`)).data;
  },
  async save(clientId, galaxsysSettings) {
    await Vue.http.post(`/api/galaxsys/settings/byclient/${clientId}`, galaxsysSettings);
    noty.success('Settings saved successfully');
  }
}



// WEBPACK FOOTER //
// ./src/services/galaxsys.service.js